function Barbados({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_611)">
      <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5069 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5069 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#FFDA44"/>
      <path d="M9.0435 1.58813C3.69163 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69163 27.8239 9.0435 30.4117V1.58813Z" fill="#0052B4"/>
      <path d="M22.9565 1.58813V30.4117C28.3084 27.8239 32 22.3433 32 15.9999C32 9.65663 28.3084 4.17601 22.9565 1.58813Z" fill="#0052B4"/>
      <path d="M20.8696 9.73909L21.8029 10.2057L20.8696 9.73909L19.9362 9.27247C19.88 9.38503 18.6613 11.8646 18.4622 15.6522H17.0435V9.73909L16 8.34778L14.9565 9.73909V15.6522H13.5378C13.3387 11.8646 12.1201 9.38503 12.0638 9.27247L10.1971 10.2058C10.21 10.2314 11.4783 12.813 11.4783 16.6957V17.7392H14.9566V23.6522H17.0435V17.7392H20.5218V16.6956C20.5218 14.6882 20.8691 13.033 21.1605 11.9978C21.4782 10.8691 21.8009 10.2099 21.8041 10.2033L20.8696 9.73909Z" fill="black"/>
    </g>
  </svg>
  `;

  return baseXml;
}

export default Barbados;
